export default "__VITE_ASSET__CCOdTN9K__"